import React from 'react';


const Footer  = (props) => {
    return <div style={{textAlign:'center', padding: '1.5rem'}}>OfficeMojo - Automated Reminders  2.5a <br />&copy; ProSites 2018-2021</div>
}

export {Footer};